(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminAppDisplaySettingsController', AdminAppDisplaySettingsController);

    function AdminAppDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        recurrenceRulesService,
        elbSettings,
        $state,
        module,
        modulesService
    ) {
        const vm = this;
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'app_timeout'
            ],
            recurrenceRulesService: recurrenceRulesService,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService
        });

        angular.extend(vm, base);
    }
})();
